import { render, staticRenderFns } from "./BackendLayout.vue?vue&type=template&id=5bd27d63&scoped=true"
import script from "./BackendLayout.vue?vue&type=script&lang=js"
export * from "./BackendLayout.vue?vue&type=script&lang=js"
import style0 from "./BackendLayout.vue?vue&type=style&index=0&id=5bd27d63&prod&lang=scss"
import style1 from "./BackendLayout.vue?vue&type=style&index=1&id=5bd27d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd27d63",
  null
  
)

export default component.exports